import Icons, { IconsProps } from '../../Icons';

export type TipsAndUpdatesProps = IconsProps;

export function TipsAndUpdates(props: TipsAndUpdatesProps) {
  return (
    <Icons {...props}>
      <path d="m21 10.563-.475-1.026-1.025-.475 1.025-.475L21 7.562l.475 1.025 1.025.475-1.025.475L21 10.562Zm-3-4.226-.725-1.55-1.55-.725 1.55-.725.725-1.55.725 1.55 1.55.725-1.55.725L18 6.337ZM8 22.212c-.467 0-.867-.154-1.2-.462a1.885 1.885 0 0 1-.6-1.137h3.6c-.067.45-.267.829-.6 1.137a1.706 1.706 0 0 1-1.2.462Zm-3.5-3.375v-1h7v1h-7Zm.05-2.774a6.974 6.974 0 0 1-2.225-2.35c-.55-.95-.825-2-.825-3.15 0-1.817.63-3.355 1.888-4.614C4.646 4.691 6.183 4.062 8 4.062c1.817 0 3.354.63 4.613 1.887 1.258 1.26 1.887 2.797 1.887 4.614 0 1.15-.275 2.2-.825 3.15a6.974 6.974 0 0 1-2.225 2.35h-6.9Zm.3-1h6.3a5.545 5.545 0 0 0 1.737-1.976 5.379 5.379 0 0 0 .613-2.524c0-1.534-.533-2.834-1.6-3.9-1.067-1.067-2.367-1.6-3.9-1.6s-2.833.533-3.9 1.6c-1.067 1.066-1.6 2.366-1.6 3.9 0 .9.204 1.741.613 2.524a5.545 5.545 0 0 0 1.737 1.976Z" />
    </Icons>
  );
}

// https://www.zhangxinxu.com/sp/svgo/
// https://jakearchibald.github.io/svgomg/
